import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Table, { TableRow, TableRowCell } from 'core-system/Table'
import Text from 'core-system/Text'
import PlatformSvg from 'core-system/Icons/PlatformSvg'
import palette from 'core-system/Themes/palette'
import Request from 'redux/config/services/Request'

interface CommuterTableInfo {
  name: string
  corporateId: string | null
  email: string
}

const NameIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`

const NameIdContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const renderCommuterRows = (commuterList: CommuterTableInfo[]) => {
  return commuterList.map((commuter, idx) => {
    return (
      <TableRow key={idx}>
        <TableRowCell>
          <NameIconContainer>
            <PlatformSvg
              folder='users'
              variant='userBasic'
              width={40}
              height={40}
            />
            <NameIdContainer>
              <Text variant='action4' hideOverflow>
                {commuter.name}
              </Text>
              {commuter.corporateId ? (
                <Text
                  variant='body2'
                  textColor={palette.text.placeholder}
                  hideOverflow
                >
                  {`#${commuter.corporateId}`}
                </Text>
              ) : null}
            </NameIdContainer>
          </NameIconContainer>
        </TableRowCell>
        <TableRowCell>{commuter.email}</TableRowCell>
      </TableRow>
    )
  })
}

interface OptInQuestionNoResponsesProps {
  isMobile: boolean
  optInId: string
}

const OptInQuestionNoResponses = React.memo(
  (props: OptInQuestionNoResponsesProps) => {
    const { optInId } = props
    const [rows, setRows] = useState<CommuterTableInfo[]>([])

    useEffect(() => {
      if (!optInId) return
      let cancelled = false
      Request.get(`/hr/concierge/opt_ins/${optInId}/non-responders/`).then(
        (response) => {
          if (cancelled) return
          const results = response.data || []
          setRows(
            results.map(
              (employee: {
                name: string
                email: string
                employeeCorporateId?: string
              }) => ({
                name: employee.name,
                email: employee.email,
                corporateId: employee.employeeCorporateId || null,
              })
            )
          )
        }
      )
      return () => {
        cancelled = true
      }
    }, [optInId])

    return (
      <Table
        headerCells={[
          <TableRowCell>Commuter</TableRowCell>,
          <TableRowCell>Email</TableRowCell>,
        ]}
        emptyMessage='All Commuters Have Responded'
        rows={rows.length > 0 ? renderCommuterRows(rows) : null}
      />
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  OptInQuestionNoResponses.displayName = 'OptInQuestionNoResponses'
}

export default OptInQuestionNoResponses
